import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { Modal, ModalHeader } from 'reactstrap'
import './style.css'

// Almost the whole screen (1rem gap all around). Set inline so no stylesheet
// (bootstrap's centered/scrollable modal rules, page CSS, ...) can shrink it.
const fullHeightStyle = {
  width: '96vw',
  maxWidth: '96vw',
  height: 'calc(100vh - 2rem)',
  maxHeight: 'calc(100vh - 2rem)',
  minHeight: 0,
  margin: '1rem auto',
}

const CustomModal = (props) => {
  const [showModal, setShowModal] = useState(true)
  const history = useHistory()
  const handleCloseModal = () => setShowModal(false)

  useEffect(() => {
    if (!showModal) {
      history.replace(props.backPath)
    }
  }, [showModal])

  return (
    <Modal
      onClosed={props.onClosed}
      isOpen={showModal}
      toggle={handleCloseModal}
      centered
      size={props.size}
      style={props.fullHeight ? { ...fullHeightStyle, ...props.style } : props.style}
      className={props.className}
      contentClassName={props.fullHeight ? 'modal-fullheight-content' : undefined}
      enforceFocus={false}
      scrollable
    >
      <ModalHeader className='border-bottom pb-2' toggle={handleCloseModal}>
        {props.title}{' '}
      </ModalHeader>
      {props.children}
    </Modal>
  )
}

export default CustomModal
